import { HStack } from 'native-base';
import { useTranslation } from 'react-i18next';
import { Platform } from 'react-native';

import { PrinterIcon } from '../icons/printer';
import { MsExcel } from '../icons/ms-excel';
import type { ExportScope } from '../types';
import { ColumnsPopover } from './columns-popover';
import type { ChipDef } from './equipment-filter-chips';
import { EquipmentFilterChips } from './equipment-filter-chips';
import { ExportButton } from './export-button';
import { GroupFilter } from './group-filter';
import type { SensorColumnDef } from './sensor-table';

type GridToolbarProps = {
  chips: ChipDef[];
  quickValue: string;
  onQuickChange: (id: string) => void;
  groups: string[];
  groupFilter: string[];
  onGroupFilterChange: (groups: string[]) => void;
  columns: SensorColumnDef[];
  visibleColumnIds: string[];
  onColumnsChange: (ids: string[]) => void;
  onPrint: (scope: ExportScope) => void;
  onExcel: (scope: ExportScope) => void;
};

export const GridToolbar = ({
  chips,
  quickValue,
  onQuickChange,
  groups,
  groupFilter,
  onGroupFilterChange,
  columns,
  visibleColumnIds,
  onColumnsChange,
  onPrint,
  onExcel,
}: GridToolbarProps) => {
  const { t } = useTranslation();

  return (
    <HStack px={3} py={2} space={2} alignItems="center" justifyContent="space-between" borderBottomWidth={1} borderColor="gray.200">
      {/* Left: quick-filter chips */}
      <HStack flex={1} flexWrap="wrap" alignItems="center">
        <EquipmentFilterChips chips={chips} value={quickValue} onChange={onQuickChange} />
      </HStack>

      {/* Right: group filter + columns + print + excel */}
      <HStack space={2} alignItems="center">
        <GroupFilter groups={groups} value={groupFilter} onChange={onGroupFilterChange} />
        <ColumnsPopover columns={columns} visibleIds={visibleColumnIds} onChange={onColumnsChange} />
        {Platform.OS === 'web' && (
          <>
            <ExportButton icon={<PrinterIcon size={5} color="gray.700" />} label={t('store_equipment:print')} onSelect={onPrint} />
            <ExportButton icon={<MsExcel width={20} height={20} />} label={t('store_equipment:excel')} onSelect={onExcel} />
          </>
        )}
      </HStack>
    </HStack>
  );
};
